
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiURL: 'https://api-gsctool-dev.actionlabs.com.br/api/1.0',
  loginApiURL: 'https://api-gsctool-dev.actionlabs.com.br/api/1.0/login',
  mapsKey: 'AIzaSyCRi5ue-kjzEVJQHlrLJKfKacGr_EQwoAQ',
  deployUrl: 'https://gsctool-web-dev.actionlabs.com.br/',

  auth: {
    clientID: '1d0ISuZtuxgEaXx0bu571phxBr954YQ8',
    domain: 'auth.brightcities.city',
    audience: 'brightcities.actionlabs.com.br',
    callbackURL: 'https://gsctool-web-dev.actionlabs.com.br/loggedIn'
  },
  stripeKey: 'pk_test_51OMpM8HRs7v825lkiq7FX4kh8yTCTtS3Au4wimwL6WMRgHtVzLSHOMCT07cUI3yYV5AKG55mBB29s1f2gastGzmB00ltiweYD0',

  monitoring: {
    enabled: false,
    collectorUrl: '',
    apiKey: ''
  }
}